export { FlexProductCode } from './types/FlexProductCode.mjs';

const COOKIE_KEY_VERSION_IDENTIFIER = "FlexTeam-Version";
const COOKIE_VALUE_V2_VERSION_IDENTIFIER = "V2";
const COOKIE_KEY_AID = "AID";
const COOKIE_KEY_WS_AID = "V2_WS_AID";
const COOKIE_KEY_WS_RID = "V2_WS_RID";
const COOKIE_KEY_WS_FFA = "V2_WS_FFA";
const COOKIE_KEY_DEVICE_ID = "DEVICE_ID";
const COOKIE_KEY_CURRENT_CUSTOMER_INFO = "V2_CUSTOMER_INFO";
const COOKIE_KEY_LOGIN_ERROR_MESSAGE = "V2_LOGIN_ERROR";
const HEADER_KEY_REAUTH_TOKEN = "x-flex-ffa";
const HEADER_KEY_API_ACCESS_TOKEN = "x-flex-aid";
const HEADER_KEY_MF_APP_NAME = "flexteam-mf-appname";
const HEADER_KEY_MF_APP_VERSION = "flexteam-mf-appversion";
const HEADER_KEY_DEVICE_ID = "flexteam-deviceid";
const HEADER_KEY_PRODUCT_CODE = "flexteam-productcode";
const COOKIE_MAX_AGE = 400 * 60 * 60 * 24;
const SECURED_COOKIE_OPTIONS = (stage) => ({ secure: stage === "prod" });
const DEFAULT_COOKIE_OPTIONS = {
  sameSite: "lax",
  path: "/"
};
const SESSION_CHANGE_MESSAGE = {
  KEY: "session_message",
  SIGN_OUT: "signedOut",
  TIMEOUT: "timedOut",
  CHANGE_PREFIX: "changed:"
};

export { COOKIE_KEY_AID, COOKIE_KEY_CURRENT_CUSTOMER_INFO, COOKIE_KEY_DEVICE_ID, COOKIE_KEY_LOGIN_ERROR_MESSAGE, COOKIE_KEY_VERSION_IDENTIFIER, COOKIE_KEY_WS_AID, COOKIE_KEY_WS_FFA, COOKIE_KEY_WS_RID, COOKIE_MAX_AGE, COOKIE_VALUE_V2_VERSION_IDENTIFIER, DEFAULT_COOKIE_OPTIONS, HEADER_KEY_API_ACCESS_TOKEN, HEADER_KEY_DEVICE_ID, HEADER_KEY_MF_APP_NAME, HEADER_KEY_MF_APP_VERSION, HEADER_KEY_PRODUCT_CODE, HEADER_KEY_REAUTH_TOKEN, SECURED_COOKIE_OPTIONS, SESSION_CHANGE_MESSAGE };
//# sourceMappingURL=constants.mjs.map
